export default __webpack_public_path__ + "static/media/materials.1d673563.webp";